// src/store/store.auth.js
import { makeAuthPlugin } from '../feathers-client.js'

export default makeAuthPlugin({ userService: 'users' })
